export const api = {
    GET_CARDS_LIST_API: "/api/usercards/list",
    EDIT_CARD_API : "/api/usercards/edit",
    ADD_CARD_API : "/api/usercards/add",
    GET_CARD_API : "/api/usercards/getCard",
    GET_CARD_BY_BARCODE_API : "/api/usercards/getCardByBarcode",
    REMOVE_CARD_API : "/api/usercards/removeCard"
}